import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_GALLERIES_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/galleries',
        iconClass: 'fas fa-photo-video',
        name: 'Galleries',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.Galleries',
        order: 2
      },
    ]);
  };
}
